module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-my cert-list"
  }, [_c('navbar', {
    attrs: {
      "title": "证照管理"
    }
  }), _vm._v(" "), (_vm.paperList.length !== 0) ? _c('span', {
    staticClass: "paper-edit",
    on: {
      "click": _vm.editPaper
    }
  }, [_vm._v(_vm._s(_vm.editFont))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "common-scroll",
    staticStyle: {
      "bottom": "65px"
    },
    attrs: {
      "id": "common-scroll"
    }
  }, [_c('ul', {
    staticClass: "ui-listview paper-listview"
  }, _vm._l((_vm.paperList), function(list, index) {
    return (!_vm.editStatus) ? _c('li', [_c('router-link', {
      staticClass: "ui-btn-icon-right ui-icon-carat-r",
      attrs: {
        "to": {
          path: '/paper-detail',
          query: {
            status: 'edit',
            uid: list.id
          }
        }
      }
    }, [_vm._v(_vm._s(list.name))])], 1) : _c('li', [_vm._v(_vm._s(list.name)), _c('span', {
      staticClass: "paper-reduce",
      on: {
        "click": function($event) {
          return _vm.delPaper(list.id)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('refresh', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    attrs: {
      "cls": _vm.cls,
      "font": _vm.font
    }
  }), _vm._v(" "), _c('mid-ware', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.midware),
      expression: "midware"
    }],
    attrs: {
      "icon": _vm.icon,
      "midFont": _vm.midFont
    }
  })], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "paper-new-add",
    attrs: {
      "to": {
        path: '/paper-detail',
        query: {
          status: 'add'
        }
      }
    }
  }, [_vm._v("新增证照")]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  }), _vm._v(" "), _c('tips-t', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipst),
      expression: "tipst"
    }],
    ref: "tipst",
    attrs: {
      "hasTipsFont": _vm.hasTipsFont,
      "btnFont": _vm.btnFont,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-604b4496!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PaperManager.vue
// module id = 577
// module chunks = 1